import * as React from 'react';
let { connect } = require('react-redux');
import { ErrorModal as ErrorModalComponent } from './../../components/modals/errorModal';
export const mapStateToProps = (state, ownProps)=>{
    return {
        localizedStrings: state.config.locStrings
    };
};
const ErrorModal = connect(mapStateToProps)(ErrorModalComponent);
export default ErrorModal;
